import { InputHTMLAttributes, forwardRef, useId } from 'react'
import styles from './Input.module.css'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string
  helperText?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    const id = useId()
    const errorId = `${id}-error`
    const helperId = `${id}-helper`

    const describedBy = [error ? errorId : '', helperText ? helperId : '']
      .filter(Boolean)
      .join(' ')

    return (
      <div className={styles.wrapper}>
        <label htmlFor={id} className={styles.label}>
          {label}
          {props.required && <span className={styles.required}>*</span>}
        </label>
        <input
          ref={ref}
          id={id}
          className={`${styles.input} ${error ? styles.error : ''} ${className}`}
          aria-invalid={!!error}
          aria-describedby={describedBy || undefined}
          {...props}
        />
        {error && (
          <p id={errorId} className={styles.errorText} role="alert">
            {error}
          </p>
        )}
        {helperText && !error && (
          <p id={helperId} className={styles.helperText}>
            {helperText}
          </p>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'
